var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 53,
    viewBox: "0 0 222 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54886_14082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0799 10.5594C36.2427 8.70968 34.1935 5.7484 33.5552 2.2972C33.417 1.55145 33.3416 0.783945 33.3416 -0.00146484H24.285L24.271 36.2962C24.1187 40.3614 20.7737 43.6233 16.6727 43.6233C15.3986 43.6233 14.1975 43.3048 13.1409 42.7484C10.7182 41.473 9.05908 38.9326 9.05908 36.0097C9.05908 31.8115 12.4745 28.3961 16.6727 28.3961C17.4568 28.3961 18.2077 28.5253 18.9189 28.7479V19.502C18.1834 19.4022 17.4351 19.3396 16.6727 19.3396C7.47803 19.3408 0 26.8189 0 36.011C0 41.6508 2.81801 46.6422 7.1173 49.6597C9.8253 51.5606 13.1192 52.6811 16.6714 52.6811C25.8635 52.6811 33.3416 45.2031 33.3416 36.011V17.605C36.8938 20.1544 41.2455 21.6574 45.9427 21.6574V12.6009C43.4125 12.6009 41.0562 11.8488 39.0812 10.5606L39.0799 10.5594Z",
    fill: "#00E387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5924 12.6444H83.1524L80.5301 20.8157L73.1212 20.8132V51.022H63.8894V20.8132L54.6001 20.8298L54.5937 12.6444H54.5924Z",
    fill: "#00E387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.936 12.6444H159.156L156.533 20.8157L148.478 20.8132V51.022H139.232V20.8132L129.943 20.8298L129.937 12.6444H129.936Z",
    fill: "#00E387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8934 24.8515H94.0497L94.0394 51.022H84.9471L84.8934 24.8515Z",
    fill: "#00E387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6812 12.5369H106.827V30.4095L115.891 21.5142H126.81L115.344 32.6416L128.187 51.022H118.11L109.539 38.2764L106.827 40.9115V51.022H97.6812V12.5369Z",
    fill: "#00E387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.685 12.5369H199.831V30.4095L208.895 21.5142H219.814L208.347 32.6416L221.19 51.022H211.113L202.542 38.2764L199.831 40.9115V51.022H190.685V12.5369Z",
    fill: "#00E387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.469 21.8608C92.0144 21.8608 94.0778 19.7974 94.0778 17.252C94.0778 14.7066 92.0144 12.6431 89.469 12.6431C86.9236 12.6431 84.8601 14.7066 84.8601 17.252C84.8601 19.7974 86.9236 21.8608 89.469 21.8608Z",
    fill: "#00E387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3 19.6901C162.648 19.6901 155.634 26.7037 155.634 35.356C155.634 44.0083 162.648 51.022 171.3 51.022C179.952 51.022 186.966 44.0083 186.966 35.356C186.966 26.7037 179.952 19.6901 171.3 19.6901ZM171.3 42.9709C167.094 42.9709 163.684 39.5607 163.684 35.3548C163.684 31.1489 167.094 27.7386 171.3 27.7386C175.506 27.7386 178.916 31.1489 178.916 35.3548C178.916 39.5607 175.506 42.9709 171.3 42.9709Z",
    fill: "#00E387"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54886_14082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221.19,
    height: 52.6813,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTiktok);
export default __webpack_public_path__ + "static/media/logo_tiktok.0077370e55e5f5d654dbd2c93de1abff.svg";
export { ForwardRef as ReactComponent };